export enum AuthorityCashMovement {
  BANKING_ENTRIES_CASH_MOVEMENT_REPORT = '3.6.3',
  BANKING_ENTRIES_CASH_MOVEMENT_ADD = '3.6.2',
  BANKING_ENTRIES_CASH_MOVEMENT_VIEW = '3.6.1',
  BANKING_ENTRIES_CASH_MOVEMENT = '3.6',
}
